// src/pages/restricoes/Restricoes.js
import React, { useState } from "react";
import "./restricoes.css";

const API_BASE = process.env.REACT_APP_API_BASE || "";

function Restricoes() {
  const [selecionadas, setSelecionadas] = useState([]);
  const [outraRestricao, setOutraRestricao] = useState("");
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [tipoMensagem, setTipoMensagem] = useState(""); // "sucesso" | "erro"

  // Opções fixas — IDs mantidos (backend intacto)
  const opcoesFixas = [
    {
      id: "evita_acucar",
      label: "Evito açúcar ou alimentos muito doces",
    },
    {
      id: "evita_lactose",
      label: "Evito leite ou lactose",
    },
    {
      id: "evita_gluten",
      label: "Evito glúten",
    },
    {
      id: "evita_sodio",
      label: "Evito alimentos muito salgados",
    },
  ];

  const isNenhumaSelecionada = selecionadas.includes("nenhuma");

  // ✅ NOVA CONDIÇÃO: ativa sticky sempre que houver interação válida
  const isStickyAtivo =
    selecionadas.length > 0 || outraRestricao.trim().length > 0;

  const toggleOpcao = (id) => {
    setMensagem("");
    setTipoMensagem("");

    if (id === "nenhuma") {
      if (selecionadas.includes("nenhuma")) {
        setSelecionadas([]);
      } else {
        setSelecionadas(["nenhuma"]);
      }
      return;
    }

    let novaLista = selecionadas.filter((item) => item !== "nenhuma");

    if (novaLista.includes(id)) {
      novaLista = novaLista.filter((item) => item !== id);
    } else {
      novaLista = [...novaLista, id];
    }

    setSelecionadas(novaLista);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensagem("");
    setTipoMensagem("");

    if (selecionadas.length === 0 && outraRestricao.trim() === "") {
      setTipoMensagem("erro");
      setMensagem(
        "Selecione pelo menos uma opção ou informe algum alimento ou ingrediente que você evita."
      );
      return;
    }

    setLoading(true);
    try {
      const resp = await fetch(`${API_BASE}/salvar_restricoes.php`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          restricoesSelecionadas: selecionadas,
          outraRestricao: outraRestricao.trim(),
        }),
      });

      const data = await resp.json();
      setLoading(false);

      if (data.status === "sucesso") {
        setTipoMensagem("sucesso");
        setMensagem(
          "Preferências salvas com sucesso. Redirecionando para o painel..."
        );

        setTimeout(() => {
          window.location.href = "/painel";
        }, 1000);
      } else {
        setTipoMensagem("erro");
        setMensagem(
          data.mensagem ||
            "Não foi possível salvar as preferências. Tente novamente."
        );
      }
    } catch (err) {
      setLoading(false);
      setTipoMensagem("erro");
      setMensagem("Erro ao conectar com o servidor. Tente novamente.");
    }
  };

  return (
    <div
      className={
        isStickyAtivo
          ? "restricoes-page restricoes-page--sticky"
          : "restricoes-page"
      }
    >
      <div className="restricoes-card">
        <header className="restricoes-header">
          <h1 className="restricoes-titulo">
            Preferências e alimentos evitados
          </h1>
          <p className="restricoes-subtitulo">
            Essas informações ajudam a evitar sugestões de alimentos que você
            prefere não consumir. As sugestões são gerais e educativas.
          </p>
        </header>

        <form className="restricoes-form" onSubmit={handleSubmit}>
          {/* BLOCO: NENHUMA */}
          <div className="restricoes-bloco">
            <h2 className="restricoes-bloco-titulo">
              Você evita algum alimento ou ingrediente?
            </h2>
            <label className="restricoes-opcao restricoes-opcao-nenhuma">
              <input
                type="checkbox"
                className="restricoes-checkbox"
                checked={isNenhumaSelecionada}
                onChange={() => toggleOpcao("nenhuma")}
              />
              <span>Não evito nenhum ingrediente específico</span>
            </label>
          </div>

          {/* BLOCO: OPÇÕES FIXAS */}
          <div className="restricoes-bloco">
            <h2 className="restricoes-bloco-titulo">
              Se sim, selecione o que se aplica:
            </h2>

            <div className="restricoes-opcoes-grid">
              {opcoesFixas.map((op) => (
                <label key={op.id} className="restricoes-opcao">
                  <input
                    type="checkbox"
                    className="restricoes-checkbox"
                    checked={selecionadas.includes(op.id)}
                    onChange={() => toggleOpcao(op.id)}
                    disabled={isNenhumaSelecionada}
                  />
                  <span>{op.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* BLOCO: OUTRA */}
          <div className="restricoes-bloco">
            <h2 className="restricoes-bloco-titulo">
              Deseja informar algum ingrediente específico?
            </h2>
            <p className="restricoes-texto-ajuda">
              Liste alimentos ou ingredientes que você prefere evitar.
              Exemplos: “amendoim”, “camarão”, “leite”, “frituras”.
            </p>

            <textarea
              className="restricoes-textarea"
              rows={4}
              placeholder="Ex: Evito amendoim, leite e alimentos fritos."
              value={outraRestricao}
              onChange={(e) => setOutraRestricao(e.target.value)}
              disabled={isNenhumaSelecionada}
            />
          </div>

          {/* MENSAGENS */}
          {mensagem && (
            <div
              className={
                tipoMensagem === "sucesso"
                  ? "restricoes-msg restricoes-msg-sucesso"
                  : "restricoes-msg restricoes-msg-erro"
              }
            >
              {mensagem}
            </div>
          )}

          {/* BOTÃO FINAL (STICKY CORRIGIDO) */}
          <div
            className={
              isStickyAtivo
                ? "restricoes-footer restricoes-footer--sticky"
                : "restricoes-footer"
            }
          >
            <button
              type="submit"
              className="restricoes-botao"
              disabled={loading}
            >
              {loading ? "Salvando..." : "Salvar e continuar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Restricoes;
